"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  STORE: 'store',
  ACCOUNT: 'account',
  CHECKOUT: 'checkout'
};
exports["default"] = _default;
module.exports = exports.default;
module.exports.default = exports.default;